import "./css/ResetPassword.css";
import AuthContainer from "./AuthContainer";
import AuthSectionContainer from "./AuthSectionContainer";
import { FormControl, TextField } from "@mui/material";
import useManageInput from "../hooks/useManageInput";
import { ButtonLanding } from "../../../components/Buttons";
import useResetPassword from "../hooks/useResetPassword";
import ResponseStatus from "./ResponseStatus";
import { Link, useSearchParams } from "react-router-dom";

function ResetPassword() {
  const {
    value: password,
    valueIsValid: passwordIsValid,
    error: passwordError,
    setValue: setPassword,
    setError: setPasswordError,
    showError: showPasswordError,
  } = useManageInput("password", {
    required: true,
    minChar: 6,
  });

  const {
    value: passConfirm,
    valueIsValid: passConfirmIsValid,
    error: passConfirmError,
    setValue: setPassConfirm,
    setError: setPassConfirmError,
    showError: showPassConfirmError,
  } = useManageInput("confirm password", {
    required: true,
    rule: {
      regex: new RegExp(`${password}`),
      message: "Password does not matched",
    },
  });

  const handleRequestError = (errors) => {
    if (!errors) return;
    setPasswordError(errors?.password?.[0]);
    setPassConfirmError(errors?.password?.[0]);
  };

  const [resetPassword, resettingPass, passResetError, passResetSuccess] =
    useResetPassword();

  const [searchParams, setSearchParams] = useSearchParams();

  const submitHandler = async (e) => {
    e.preventDefault();

    showPasswordError();
    showPassConfirmError();

    if (passwordIsValid && passConfirmIsValid) {
      const response = await resetPassword(
        searchParams.get("token"),
        password,
        passConfirm
      );
      if (!response) return;
      setPasswordError(response?.password);
      setPassConfirmError(response?.password);
    }
  };

  return (
    <AuthContainer>
      <AuthSectionContainer title="Rest Password" className={"reset-pw"}>
        <ResponseStatus status={passResetError && "error"}>
          {passResetError}. &nbsp;
          {passResetError && <Link to={"/forgot-pw"}>Get new one</Link>}
        </ResponseStatus>
        <ResponseStatus status="success">{passResetSuccess}</ResponseStatus>
        {passResetSuccess ? (
          <div className="reset-redirect">
            <Link to={"/login"} className="redirect">
              Login
            </Link>
          </div>
        ) : (
          <form onSubmit={submitHandler}>
            <FormControl>
              <p className="error-message">{passwordError && passwordError}</p>
              <TextField
                id="password"
                label="New password"
                variant="outlined"
                size="normal"
                type="password"
                fullWidth
                value={password}
                error={passwordError ? true : false}
                onChange={(e) => setPassword(e.target.value)}
              />
            </FormControl>
            <FormControl>
              <p className="error-message">
                {passConfirmError && passConfirmError}
              </p>
              <TextField
                id="password_confirmation"
                label="Confirm password"
                variant="outlined"
                size="normal"
                type="password"
                fullWidth
                value={passConfirm}
                error={passConfirmError ? true : false}
                onChange={(e) => setPassConfirm(e.target.value)}
              />
            </FormControl>
            <ButtonLanding
              type="submit"
              name="Reset"
              style={{ marginTop: "1rem" }}
              loading={resettingPass}
            />
          </form>
        )}
      </AuthSectionContainer>
    </AuthContainer>
  );
}

export default ResetPassword;
